import { FlowBuilderElement } from '../../../_components/flow-builder/FlowBuilder';
import { FlowConnector, StepItem } from '../../../_components/flow-builder/TypeDefs';
import { Orientation } from '../../../_components/flow-builder/canvas-element/Orientation';
import { AssociatedService, CreateJourneyStepDetails, EventSchemaDetail, IngressEvent, JourneyComments, Service, ServiceOperation } from '../../../store/_api/TypeDefs';
import { CompensatoryEventMap, DraggingItemType, FlowItemDataMap, PayloadTransformation, SelectedFlowItem, SidebarState, StepJourneyDataMap } from '../utility/TypeDefs';

export enum Actions {
  NONE_SELECTED = 'NONE_SELECTED',
  DELETE_FLOW_ITEM = 'DELETE_FLOW_ITEM',
  DELETE_CONNECTOR = 'DELETE_CONNECTOR',
  SELECT_START = 'SELECT_START',
  HIDE_SIDEBAR = 'HIDE_SIDEBAR',
  SIDEBAR_DATA_LOADING = 'SIDEBAR_DATA_LOADING',
  SIDEBAR_DATA_ERROR = 'SIDEBAR_DATA_ERROR',
  LOAD_MORE_SERVICES = 'LOAD_MORE_SERVICES',
  MORE_SERVICES_LOAD_FAILED = 'MORE_SERVICES_LOAD_FAILED',
  SELECT_CONNECTOR = 'SELECT_CONNECTOR',
  FLOW_BUILDER_SIZE = 'FLOW_BUILDER_SIZE',
  SELECT_FLOW_ITEM = 'SELECT_FLOW_ITEM',
  CONNECTOR_DRAW = 'CONNECTOR_DRAW',
  FLOW_ITEM_DRAG_COMPLETE = 'FLOW_ITEM_DRAG_COMPLETE',
  SEARCH_ITEMS = 'SEARCH_ITEMS',
  FETCH_ALL_SERVICES_AND_JOURNEY_DATA = 'FETCH_ALL_SERVICES_AND_JOURNEY_DATA',
  PICK_SERVICE = 'PICK_SERVICE',
  CREATE_FLOW_ITEM = 'CREATE_FLOW_ITEM',
  DRAGGING_ITEM = 'DRAGGING_ITEM',
  SAVE_JOURNEY_BTN_ENABLE = 'SAVE_JOURNEY_BTN_ENABLE',
  FETCH_ALL_ASSOCIATED_SERVICES = 'FETCH_ALL_ASSOCIATED_SERVICES',
  SET_EVENT_SCHEMA = 'SET_EVENT_SCHEMA',
  CLEAR_EVENT_SCHEMA = 'CLEAR_EVENT_SCHEMA',
  PICK_INGRESS_EVENT = 'PICK_INGRESS_EVENT',
  LOAD_JOURNEY_METADATA = 'LOAD_JOURNEY_METADATA',
  MORE_SERVICES_LOADED = 'MORE_SERVICES_LOADED',
  SAVE_JOURNEY_SUCCESS = 'SAVE_JOURNEY_SUCCESS',
  FETCH_SERVICE_OPERATIONS = 'FETCH_SERVICE_OPERATIONS',
  DESIGN_COMPENSATORY_EVENT_MAP = 'DESIGN_COMPENSATORY_EVENT_MAP',
  CANCEL_COMPENSATORY_EVENT_MAP = 'CANCEL_COMPENSATORY_EVENT_MAP',
  SAVE_COMPENSATORY_EVENT_MAP = 'SAVE_COMPENSATORY_EVENT_MAP',
  RESTORE_PARENT_JOURNEY = 'RESTORE_PARENT_JOURNEY',
  LOAD_COMPENSATORY_EVENT_MAP = 'LOAD_COMPENSATORY_EVENT_MAP',
  DELETE_COMPENSATORY_EVENT_MAP = 'DELETE_COMPENSATORY_EVENT_MAP',
  HIDE_DELETE_NOTIFY_DIALOG = 'HIDE_DELETE_NOTIFY_DIALOG',
  NOTIFY_DELETE_NODE = 'NOTIFY_DELETE_NODE',
  NOTIFY_DELETE_CEM = 'NOTIFY_DELETE_CEM',
  SET_SEARCH_DATA = 'SET_SEARCH_DATA',
  NOTIFY_DELETE_CONNECTOR = 'NOTIFY_DELETE_CONNECTOR',
  CHANGE_CONDITION_TEXT = 'CHANGE_CONDITION_TEXT',
  CLOSE_JOURNEY_STEP_MODAL = 'CLOSE_JOURNEY_STEP_MODAL',
  NOTIFY_API_ERROR = 'NOTIFY_API_ERROR',
  CLICK_STEP_CARD = 'CLICK_STEP_CARD',
  SET_JOURNEY_STEP_DETAILS = 'SET_JOURNEY_STEP_DETAILS',
  SET_VALIDATION = 'SET_VALIDATION',
  CANCEL_STEP_DESIGN = 'CANCEL_STEP_DESIGN',
  STORE_STEP_JOURNEY = 'STORE_STEP_JOURNEY',
  HIDE_API_ERROR = 'HIDE_API_ERROR',
  SET_STEP_CARD_MENU_COORDINATES = 'SET_STEP_CARD_MENU_COORDINATES',
  NOTIFY_DELETE_STEP = 'NOTIFY_DELETE_STEP',
  DELETE_STEP_ITEM = 'DELETE_STEP_ITEM',
  DISMISS_STEP_CARD_MENU_DROPDOWN = 'DISMISS_STEP_CARD_MENU_DROPDOWN',
  OPEN_SCHEDULER_MODAL = 'OPEN_SCHEDULER_MODAL',
  CLOSE_SCHEDULER_MODAL = 'CLOSE_SCHEDULER_MODAL',
  DELETE_SUBSEQUENT_STEPS = 'DELETE_SUBSEQUENT_STEPS',
  CLICK_STEP_CONNECTOR_ICON = 'CLICK_STEP_CONNECTOR_ICON',
  CLICK_INITIATE_STEP_CARD = 'CLICK_INITIATE_STEP_CARD',
  VIEW_JOURNEY_INITIATED = 'VIEW_JOURNEY_INITIATED',
  UPDATE_JOURNEY_STATUS_VER_ON_EDIT = 'UPDATE_JOURNEY_STATUS_VER_ON_EDIT',
  OPEN_PAYLOAD_TRANSFORM_MODAL = 'OPEN_PAYLOAD_TRANSFORM_MODAL',
  CLOSE_PAYLOAD_TRANSFORM_MODAL = 'CLOSE_PAYLOAD_TRANSFORM_MODAL',
  SET_PAYLOAD_FOR_CONVERGING_SERVICES = 'SET_PAYLOAD_FOR_CONVERGING_SERVICES',
  SHOW_SAVE_JOURNEY_MODAL = 'SHOW_SAVE_JOURNEY_MODAL',
  COND_EXP_SAVE = 'COND_EXP_SAVE',
  SET_SIDEBAR_INVALID_SEARCH = 'SET_SIDEBAR_INVALID_SEARCH',
  CEM_SAVE_BTN_ENABLE = 'CEM_SAVE_BTN_ENABLE',
  SHOW_COND_EXP_MODAL = 'SHOW_COND_EXP_MODAL',
  HIDE_COND_EXP_MODAL = 'HIDE_COND_EXP_MODAL',
  SET_SIDEBAR_FOR_COMMENT_HISTORY = 'SET_SIDEBAR_FOR_COMMENT_HISTORY',
  HIDE_EXTERNAL_ON_SUBSEQUENT_STEP = 'HIDE_EXTERNAL_ON_SUBSEQUENT_STEP',
  EDIT_STEP_DETAILS = 'EDIT_STEP_DETAILS',
  SHOW_EXTERNAL_EVENT_CONFIRMATION_MODAL = 'SHOW_EXTERNAL_EVENT_CONFIRMATION_MODAL',
  HIDE_EXTERNAL_EVENT_CONFIRMATION_MODAL = 'HIDE_EXTERNAL_EVENT_CONFIRMATION_MODAL',
  EXTERNAL_EVENT_CONFIRMATION_SAVE = 'EXTERNAL_EVENT_CONFIRMATION_SAVE',
  REPLACE_ALL_SERVICES_LIST = 'REPLACE_ALL_SERVICES_LIST',
  OPEN_SIDEBAR_AFTER_SERVICE_RETURN = 'OPEN_SIDEBAR_AFTER_SERVICE_RETURN'
}

/**
 * Represents the payload for a select connector.
 * @interface
 */
export interface SelectConnectorPayload {
  /**
   * The destination of the connector.
   * @type {string}
   */
  to: string;

  /**
   * The source of the connector.
   * @type {string}
   */
  from: string;
}

/**
 * Represents the payload for setting the size of a flow builder.
 * @interface
 */
export interface FlowBuilderSizePayload {
  /**
   * The width of the flow builder.
   * @type {number}
   */
  width: number;

  /**
   * The height of the flow builder.
   * @type {number}
   */
  height: number;
}

/**
 * Represents the payload for drawing a connector.
 * @interface
 */
export interface ConnectorDrawPayload {
  /**
   * The destination of the connector.
   * @type {string}
   */
  to: string;

  /**
   * The source of the connector.
   * @type {string}
   */
  from: string;

  /**
   * The orientation of the connector.
   * @type {{ from: Orientation; to: Orientation }}
   */
  orientation: { from: Orientation; to: Orientation };

  /**
   * The name of the connector.
   * @type {string}
   */
  name: string;
}

/**
 * Represents the payload for completing the drag of a flow item.
 * @interface
 */
export interface FlowItemDragCompletePayload {
  /**
   * The ID of the dragged flow item.
   * @type {string}
   */
  nodeId: string;

  /**
   * The x-coordinate of the dragged flow item.
   * @type {number}
   */
  x: number;

  /**
   * The y-coordinate of the dragged flow item.
   * @type {number}
   */
  y: number;
}

/**
 * Represents the payload for searching items.
 * @interface
 */
export interface SearchItemsPayload {
  /**
   * The services to search for.
   * @type {Service[]}
   */
  services: Service[];
}

/**
 * Represents the payload for fetching all services and journey data.
 * @interface
 */
export interface FetchAllServicesAndJourneyDataPayload {
  /**
   * The services to fetch.
   * @type {Service[]}
   */
  services?: Service[];

  /**
   * The step items to fetch.
   * @type {StepItem[]}
   */
  items: StepItem[];

  /**
   * The connectors to fetch.
   * @type {FlowConnector[]}
   */
  connectors: FlowConnector[];

  /**
   * The step journey data map to fetch.
   * @type {StepJourneyDataMap}
   */
  stepJourneyDataMap: StepJourneyDataMap;

  /**
   * The flow item data map to fetch.
   * @type {FlowItemDataMap}
   */
  flowItemDataMap: FlowItemDataMap;

  /**
   * The payload transformations to fetch.
   * @type {PayloadTransformation[]}
   */
  payloadTransformations: PayloadTransformation[];

  isCreate: boolean;
}

/**
 * Represents the payload for setting the event schema.
 * @interface
 */
export interface SetEventSchemaPayload {
  key: string;
  eventSchema: EventSchemaDetail;
}

export interface SetCurrentEventSchemaPayload {
  eventSchema: EventSchemaDetail | undefined;
}

/**
 * Represents the payload for picking a service.
 * @interface
 */
export interface PickServicePayload {
  /**
   * The picked service.
   * @type {Service | AssociatedService}
   */
  service: Service;

  serviceOperation?: ServiceOperation;

  ingressEvent?: IngressEvent;

  /**
   * The type of the dragging item.
   * @type {DraggingItemType}
   */
  type: DraggingItemType;

  /**
   * Indicates whether the action is a compensate action.
   * @type {boolean}
   */
  isCompensateAction: boolean;
}

/**
 * Represents the payload for creating a flow item.
 * @interface
 */
export interface CreateFlowItemPayload {
  /**
   * The service associated with the flow item.
   * @type {Service | AssociatedService}
   */
  service: Service | AssociatedService;

  serviceOperation?: ServiceOperation;

  ingressEvent?: IngressEvent;

  /**
   * The left position of the flow item.
   * @type {number}
   */
  left: number;

  /**
   * The top position of the flow item.
   * @type {number}
   */
  top: number;

  /**
   * The client coordinates of the flow item.
   * @type {{ x: number; y: number }}
   */
  client: { x: number; y: number };

  /**
   * The orientation of the flow item.
   * @type {Orientation}
   */
  orientation: Orientation;

  /**
   * The flow builder element associated with the flow item.
   * @type {FlowBuilderElement | null}
   */
  flowBuilder: FlowBuilderElement | null;

  /**
   * The type of the dragging item.
   * @type {DraggingItemType}
   */
  type: DraggingItemType;

  /**
   * Indicates whether the action is a compensate action.
   * @type {boolean}
   */
  isCompensateAction: boolean;
}

/**
 * Represents the payload for a dragging item.
 * @interface
 */
export interface DraggingItemPayload {
  /**
   * The item being dragged.
   * @type {Service | AssociatedService | null}
   */
  item: Service | AssociatedService | null;

  serviceOperation?: ServiceOperation;

  ingressEvent?: IngressEvent;

  /**
   * The start offset of the dragging item.
   * @type {{ x: number; y: number }}
   */
  startOffset: { x: number; y: number };

  /**
   * The type of the dragging item.
   * @type {DraggingItemType}
   */
  itemType: DraggingItemType;
}

/**
 * Represents the payload for saving a journey.
 * @interface
 */
export interface SaveJourneyPayload {
  save: boolean
}

export interface ViewEditJourneyPayload {
  flag: boolean
}

export interface FetchAllAssociatedServicesPayload {
  services: Service[]
}

export interface PickIngressEventPayload {
  serviceOps: ServiceOperation;
  ingressEvent: IngressEvent;
}

export interface LoadJourneyMetadataPayload {
  name: string,
  status: string,
  description: string,
  version: number,
  category: string,
  type: string,
  uuid?: string,
  comments?: JourneyComments[],
}

export interface MoreServicesLoadedPayload {
  services: Service[],
}

export interface FetchServiceOperationsPayload {
  serviceOperations: ServiceOperation[];
}

export interface DesignCompensatoryEventMapPayload {
  parentNodeId: string;
  compensatoryEventMap?: CompensatoryEventMap;
}

export interface DeleteFlowItemPayload {
  nodeId: string;
}

export interface DeleteStepItemPayload {
  nodeId: string;
}

export interface SaveCompensatoryEventMapPayload {
  itemDataMap: FlowItemDataMap,
  cemName?: string,
  nodeId: string
}

export interface NotifyDeleteNodePayload {
  nodeId: string;
}

export interface NotifyDeleteCemPayload {
  name: string;
}

export interface SetSearchDataPayload {
  data: string;
}

export interface NotifyDeleteConnectorPayload {
  from: string;
  to: string;
}

export interface ChangeConditionTextPayload {
  nodeId: string;
  conditionText: string;
}

export interface UpdateServiceCommonData {
  /**
   * The name of the compensatory event map.
   * @type {string | undefined}
   */
  cemName: string | undefined;

  /**
   * The ID of the node.
   * @type {string}
   */
  nodeId: string;
}

/**
 * Represents the payload for clicking a step card.
 * @interface
 */
export interface ClickStepCardPayload {
  /**
   * The ID of the node.
   * @type {string}
   */
  nodeId: string;
}

export interface ReplaceAllServicesListPayload {
  services: Service[];
}

export interface OpenSidebarAfterServiceReturnPayload {
  sidebar: SidebarState;
}

export interface SetJourneyStepDetailsPayload {
  stepName: string;
  maxExcTime: { hours: string, minutes: string, seconds: string },
  uniqueIdentifiers: string[],
  journeyStepDescription?: string,
  endpointNodeId?: string,
  isEdit: boolean,
}

/**
 * Represents the payload for setting the coordinates of the step card menu.
 * @interface
 */
export interface SetStepCardMenuCoordinatesPayload {
  /**
   * The x-coordinate of the mouse.
   * @type {number}
   */
  mouseX: number;

  /**
   * The y-coordinate of the mouse.
   * @type {number}
   */
  mouseY: number;

  /**
   * The ID of the node.
   * @type {string}
   */
  nodeId: string;
}

/**
 * Represents the payload for deleting subsequent steps.
 * @interface
 */
export interface DeleteSubsequentStepPayload {
  /**
   * The ID of the node.
   * @type {string}
   */
  nodeId: string;
}

/**
 * Represents the payload for clicking the step connector icon.
 * @interface
 */
export interface ClickStepConnectorIconPayload {
  /**
   * The ID of the previous node.
   * @type {string}
   */
  prevNodeId: string;
}

/**
 * Represents the payload for opening the payload transformation modal.
 * @interface
 */
export interface OpenPayloadTransformModalPayload {
  /**
   * The ID of the node.
   * @type {string}
   */
  nodeId: string;
}

/**
 * Represents the payload for setting the payload for converging services.
 * @interface
 */
export interface SetPayloadForConvergingServicesPayload {
  /**
   * The payload data for converging services.
   * @type {{ egress: string, ingress: string, persistentAttributes: string[] }[]}
   */
  payloadData: {
    egress: string;
    ingress: string;
    persistentAttributes: string[];
  }[],
  nodeId: string;
}

/**
 * Represents the payload for setting the service name.
 * @interface
 */
export interface SetServicePayload {
  /**
   * The name of the service.
   * @type {string}
   */
  serviceName: string;
}

/**
 * Represents the payload for setting the payload options.
 * @interface
 */
export interface SetPayloadOptionsPayload {
  /**
   * The payload options.
   * @type {string[]}
   */
  options: string[];
}

/**
 * Represents the payload for setting the show payload options.
 * @interface
 */
export interface SetShowPayloadOptionsPayload {
  /**
   * The payload option data.
   * @type {{ value: string; label: string }[]}
   */
  payloadOptionData: {
    value: string;
    label: string;
  }[];
}

/**
 * Represents the payload for saving a conditional expression.
 * @interface
 */
export interface CondExpSavePayload {
  /**
   * The ID of the node.
   * @type {string}
   */
  toNodeId: string;

  fromNodeId: string;

  /**
   * The expression to save.
   * @type {string | undefined}
   */
  expr?: string;

  /**
   * The expression builder string to save.
   * @type {string | undefined}
   */
  exprBuilderStr?: string;
}

/**
 * Represents the payload for enabling or disabling the CEM save button.
 * @interface
 */
export interface CemSaveBtnEnablePayload {
  /**
   * Indicates whether to enable or disable the CEM save button.
   * @type {boolean}
   */
  saveCem: boolean;
}

/**
 * Represents the payload for showing a conditional expression.
 * @interface
 */
export interface ShowCondExpPayload {
  /**
   * The ID of the node.
   * @type {string}
   */
  toNodeId: string;
  fromNodeId: string;
}

/**
 * Represents the payload for setting the value of unique identifiers.
 * @interface
 */
export interface SetUniqueIdentifiersValuePayload {
  /**
   * The value of the unique identifiers.
   * @type {string}
   */
  value: string;
}

export interface SaveJourneySuccessPayload {
  uuid: string;
  steps: CreateJourneyStepDetails;
  version: number;
  status: string;
  comments?: JourneyComments[];
}

export interface ShowExternalEventConfirmationPayload {
  /**
   * The ID of the node.
   * @type {string}
   */
  toNodeId: string;
  fromNodeId: string;
}

/**
 * Represents the payload for saving external value.
 * @interface
 */
export interface ExternalEventConfirmationSavePayload {
  /**
   * The ID of the node.
   * @type {string}
   */
  toNodeId: string;

  fromNodeId: string;

  /**
   * The external Value.
   * @type {boolean}
   */
  external: boolean;
}

export type UpdateActions =
  | {
    type:
    | Actions.NONE_SELECTED
    | Actions.DELETE_CONNECTOR
    | Actions.SELECT_START
    | Actions.HIDE_SIDEBAR
    | Actions.SIDEBAR_DATA_LOADING
    | Actions.SIDEBAR_DATA_ERROR
    | Actions.LOAD_MORE_SERVICES
    | Actions.MORE_SERVICES_LOAD_FAILED
    | Actions.CANCEL_COMPENSATORY_EVENT_MAP
    | Actions.RESTORE_PARENT_JOURNEY
    | Actions.LOAD_COMPENSATORY_EVENT_MAP
    | Actions.HIDE_DELETE_NOTIFY_DIALOG
    | Actions.DELETE_COMPENSATORY_EVENT_MAP
    | Actions.NOTIFY_API_ERROR
    | Actions.CANCEL_STEP_DESIGN
    | Actions.HIDE_API_ERROR
    | Actions.STORE_STEP_JOURNEY
    | Actions.NOTIFY_DELETE_STEP
    | Actions.DISMISS_STEP_CARD_MENU_DROPDOWN
    | Actions.OPEN_SCHEDULER_MODAL
    | Actions.CLOSE_SCHEDULER_MODAL
    | Actions.CLICK_INITIATE_STEP_CARD
    | Actions.CLOSE_PAYLOAD_TRANSFORM_MODAL
    | Actions.SHOW_SAVE_JOURNEY_MODAL
    | Actions.SET_SIDEBAR_INVALID_SEARCH
    | Actions.HIDE_COND_EXP_MODAL
    | Actions.SET_SIDEBAR_FOR_COMMENT_HISTORY
    | Actions.HIDE_EXTERNAL_ON_SUBSEQUENT_STEP
    | Actions.EDIT_STEP_DETAILS
    | Actions.CLOSE_JOURNEY_STEP_MODAL
    | Actions.HIDE_EXTERNAL_EVENT_CONFIRMATION_MODAL;
  }
  | {
    type: Actions.SELECT_CONNECTOR;
    payload?: SelectConnectorPayload;
  }
  | {
    type: Actions.FLOW_BUILDER_SIZE;
    payload: FlowBuilderSizePayload;
  }
  | {
    type: Actions.SELECT_FLOW_ITEM;
    payload: SelectedFlowItem;
  }
  | {
    type: Actions.CONNECTOR_DRAW;
    payload: ConnectorDrawPayload;
  }
  | {
    type: Actions.FLOW_ITEM_DRAG_COMPLETE;
    payload: FlowItemDragCompletePayload;
  }
  | {
    type: Actions.SEARCH_ITEMS;
    payload: SearchItemsPayload;
  }
  | {
    type: Actions.FETCH_ALL_SERVICES_AND_JOURNEY_DATA;
    payload: FetchAllServicesAndJourneyDataPayload;
  }
  | {
    type: Actions.PICK_SERVICE;
    payload: PickServicePayload;
  }
  | {
    type: Actions.CREATE_FLOW_ITEM;
    payload: CreateFlowItemPayload;
  }
  | {
    type: Actions.DRAGGING_ITEM;
    payload: DraggingItemPayload;
  }
  | {
    type: Actions.SAVE_JOURNEY_BTN_ENABLE;
    payload: SaveJourneyPayload;
  }
  | {
    type: Actions.FETCH_ALL_ASSOCIATED_SERVICES;
    payload: FetchAllAssociatedServicesPayload;
  }
  | {
    type: Actions.PICK_INGRESS_EVENT;
    payload: PickIngressEventPayload;
  } | {
    type: Actions.LOAD_JOURNEY_METADATA;
    payload: LoadJourneyMetadataPayload;
  } | {
    type: Actions.MORE_SERVICES_LOADED;
    payload: MoreServicesLoadedPayload;
  }
  | {
    type: Actions.FETCH_SERVICE_OPERATIONS;
    payload: FetchServiceOperationsPayload;
  }
  | {
    type: Actions.DESIGN_COMPENSATORY_EVENT_MAP;
    payload: DesignCompensatoryEventMapPayload;
  } | {
    type: Actions.DELETE_FLOW_ITEM;
    payload: DeleteFlowItemPayload;
  }
  | {
    type: Actions.SAVE_COMPENSATORY_EVENT_MAP;
    payload: SaveCompensatoryEventMapPayload;
  }
  | {
    type: Actions.NOTIFY_DELETE_NODE;
    payload: NotifyDeleteNodePayload;
  }
  | {
    type: Actions.NOTIFY_DELETE_CEM;
    payload: NotifyDeleteCemPayload;
  }
  | {
    type: Actions.SET_SEARCH_DATA;
    payload: SetSearchDataPayload;
  }
  | {
    type: Actions.NOTIFY_DELETE_CONNECTOR;
    payload: NotifyDeleteConnectorPayload;
  }
  | {
    type: Actions.CHANGE_CONDITION_TEXT;
    payload: ChangeConditionTextPayload;
  }
  | {
    type: Actions.CLICK_STEP_CARD;
    payload: ClickStepCardPayload;
  }
  | {
    type: Actions.SET_JOURNEY_STEP_DETAILS;
    payload: SetJourneyStepDetailsPayload;
  }
  | {
    type: Actions.SET_STEP_CARD_MENU_COORDINATES;
    payload: SetStepCardMenuCoordinatesPayload;
  }
  | {
    type: Actions.DELETE_STEP_ITEM;
    payload: DeleteStepItemPayload;
  }
  | {
    type: Actions.DELETE_SUBSEQUENT_STEPS;
    payload: DeleteSubsequentStepPayload;
  }
  | {
    type: Actions.CLICK_STEP_CONNECTOR_ICON;
    payload: ClickStepConnectorIconPayload;
  }
  | {
    type: Actions.VIEW_JOURNEY_INITIATED,
    payload: ViewEditJourneyPayload;
  }
  | {
    type: Actions.OPEN_PAYLOAD_TRANSFORM_MODAL,
    payload: OpenPayloadTransformModalPayload;
  }
  | {
    type: Actions.SET_PAYLOAD_FOR_CONVERGING_SERVICES,
    payload: SetPayloadForConvergingServicesPayload
  }
  | {
    type: Actions.COND_EXP_SAVE,
    payload: CondExpSavePayload
  }
  | {
    type: Actions.CEM_SAVE_BTN_ENABLE;
    payload: CemSaveBtnEnablePayload;
  }
  | {
    type: Actions.SHOW_COND_EXP_MODAL,
    payload: ShowCondExpPayload
  }
  | {
    type: Actions.SAVE_JOURNEY_SUCCESS,
    payload: SaveJourneySuccessPayload
  }
  | {
    type: Actions.SHOW_EXTERNAL_EVENT_CONFIRMATION_MODAL,
    payload: ShowExternalEventConfirmationPayload
  }
  | {
    type: Actions.EXTERNAL_EVENT_CONFIRMATION_SAVE,
    payload: ExternalEventConfirmationSavePayload
  }
  | {
    type: Actions.SET_EVENT_SCHEMA,
    payload: SetEventSchemaPayload
  }
  | {
    type: Actions.CLEAR_EVENT_SCHEMA,
    payload?: undefined
  }
  | {
    type: Actions.REPLACE_ALL_SERVICES_LIST;
    payload: ReplaceAllServicesListPayload;
  }
  | {
    type: Actions.OPEN_SIDEBAR_AFTER_SERVICE_RETURN;
    payload: OpenSidebarAfterServiceReturnPayload;
  }
